import { render, staticRenderFns } from "./profildialog.vue?vue&type=template&id=14babb78&"
import script from "./profildialog.vue?vue&type=script&lang=js&"
export * from "./profildialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports